import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import {
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow,
    Typography, Switch, TextField, Card, Badge, Chip, Dialog, DialogTitle,
    DialogContent, DialogActions, Pagination, IconButton, Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import BlockchainAdminNav from "../../components/blockchain-admin-nav";
import BlockchainAutoControl from "../../components/blockchain-auto-control";
import BlockchainBetPressure from "../../components/blockchain-bet-pressure";
import BlockchainAdminActions from "../../components/blockchain-admin-actions";
import BlockchainClassicSummary from "../../components/blockchain-classic-summary";
import { BauCuaMascotBadge } from "../../components/BauCuaMascotIcons";
import BlockchainGameGuideModal from "../../components/BlockchainGameGuideModal";

function SetBauCua60s() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState([]);
    const [bet, setBet] = useState(null);
    const [second, setSecond] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState([]);
    const [selectedResults, setSelectedResults] = useState({});
    const [payouts, setPayouts] = useState({ single: 1.996, double: 3, triple: 4, tripleAny: 25, tripleSpecific: 31, evenOdd: 1.985, chooseTwo: 5.99, color1: 1.996, color2: 4, color3: 21, allColors: 8 });

    // Modals
    const [openTileModal, setOpenTileModal] = useState(false);
    const [openLichSuPhienModal, setOpenLichSuPhienModal] = useState(false);
    const [openLichSuDatCuocModal, setOpenLichSuDatCuocModal] = useState(false);
    const [openGuideModal, setOpenGuideModal] = useState(false);

    // Filter states
    const [searchPhien, setSearchPhien] = useState("");
    const [searchUser, setSearchUser] = useState("");
    const [searchDate, setSearchDate] = useState("");
    const [phienPage, setPhienPage] = useState(1);
    const [lichSuPhienList, setLichSuPhienList] = useState([]);
    const [lichSuPhienPage, setLichSuPhienPage] = useState(1);
    const [lichSuDatCuocList, setLichSuDatCuocList] = useState([]);
    const [lichSuDatCuocPage, setLichSuDatCuocPage] = useState(1);





    const fetchHistoryPhienModal = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua60s/getHistoryBet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuPhienList(res.data.data);
                }
            })
            .catch(() => { });
    };

    const fetchRealBetHistory = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua60s/getAllBetByAdmin?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuDatCuocList(res.data.data);
                }
            })
            .catch(() => { });
    };

    const symbolNames = { 1: "Cá", 2: "Tôm", 3: "Bầu", 4: "Nai", 5: "Cua", 6: "Gà", "1": "Cá", "2": "Tôm", "3": "Bầu", "4": "Nai", "5": "Cua", "6": "Gà" };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua60s/list30bet?sanh=${SANH_ID}`).then((res) => {
            setList30(res.data.data || []);
        }).catch(() => setList30([]));
    };

    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua60s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua60s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (data) {
                    setBet(data);
                    if (data.createdAt) setDulieunhap(new Date(data.createdAt));
                }
            }
        }).catch(() => { });

        reloadHistorySilently();
        fetchCurrentBets();
    };

    const fetchSetting = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => {
            if (res.data && res.data.data) {
                const s = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (s) {
                    setPayouts({
                        single: Number(s.baucua_single || 2),
                        double: Number(s.baucua_double || 3),
                        triple: Number(s.baucua_triple || 4),
                        tripleAny: Number(s.baucua_triple_any || 25),
                        tripleSpecific: Number(s.baucua_triple_specific || 31),
                        evenOdd: Number(s.baucua_even_odd || 1.985),
                        chooseTwo: Number(s.baucua_choose_two || 5.99),
                        color1: Number(s.baucua_color_1 || 1.996),
                        color2: Number(s.baucua_color_2 || 4),
                        color3: Number(s.baucua_color_3 || 21),
                        allColors: Number(s.baucua_all_colors || 8)
                    });
                }
            }
        }).catch(() => { });
    };

    const savePayouts = () => {
        axios.put(`${process.env.REACT_APP_API_URL}/setting/update`, {
            baucua_single: Number(payouts.single),
            baucua_double: Number(payouts.double),
            baucua_triple: Number(payouts.triple),
            baucua_triple_any: Number(payouts.tripleAny),
            baucua_triple_specific: Number(payouts.tripleSpecific),
            baucua_even_odd: Number(payouts.evenOdd),
            baucua_choose_two: Number(payouts.chooseTwo),
            baucua_color_1: Number(payouts.color1),
            baucua_color_2: Number(payouts.color2),
            baucua_color_3: Number(payouts.color3),
            baucua_all_colors: Number(payouts.allColors)
        }).then(() => {
            setOpenTileModal(false);
            swal("Thành công", "Đã lưu cấu hình trả thưởng Bầu Cua.", "success");
        }).catch((error) => swal("Lỗi", error.response?.data?.message || "Không thể lưu tỉ lệ.", "error"));
    };

    useEffect(() => {
        setBet(null);
        setCurrent([]);
        fetchNewSessionAdmin();
        fetchSetting();
    }, [SANH_ID]);

    useEffect(() => {
        const timer = setInterval(() => {
            fetchCurrentBets();
            reloadHistorySilently();
            if (openLichSuDatCuocModal) fetchRealBetHistory();
            if (openLichSuPhienModal) fetchHistoryPhienModal();
        }, 1500);
        return () => clearInterval(timer);
    }, [SANH_ID, openLichSuDatCuocModal, openLichSuPhienModal]);

    useEffect(() => {
        if (!dulieunhap || isNaN(dulieunhap.getTime())) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 60 - diffInSeconds;
            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    const handleSelectSymbol = (rowId, symbolVal) => {
        setSelectedResults(prev => {
            const prevList = prev[rowId] || [];
            if (prevList.length >= 3) {
                return { ...prev, [rowId]: [prevList[1], prevList[2], symbolVal] };
            }
            return { ...prev, [rowId]: [...prevList, symbolVal] };
        });
    };

    const handleUpdateRowResult = (row) => {
        const selectedArr = selectedResults[row._id];
        let resultString = row.result;

        if (selectedArr && selectedArr.length === 3) {
            resultString = selectedArr.join(".");
        }

        const formData = { id_bet: row._id, result: resultString, sanh: SANH_ID };

        axios.post(`${process.env.REACT_APP_API_URL}/baucua60s/update`, formData)
            .then(() => {
                swal("Thành công", `Đã cài kết quả Bầu Cua 60s phiên #${row.id_bet}: ${resultString}`, "success");
                reloadHistorySilently();
            })
            .catch(() => swal("Lỗi", "Có lỗi xảy ra khi cài đặt kết quả!", "error"));
    };

    const sanhLetters = ["A", "B", "C", "D", "E", "F"];
    const formatMoney = (n) => String(n ? Math.floor(n / 1000) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const filteredLichSuPhien = (lichSuPhienList || []).filter(item =>
        String(item.id_bet || item._id).toLowerCase().includes((searchPhien || "").toLowerCase())
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" className="blockchain-admin-page happy-classic-game happy-classic-baucua" sx={{ flexGrow: 1, py: 3, px: 2, background: "#f8fafc", minHeight: "100vh" }}>
                    <Container maxWidth="xl">
                        <div className="classic-game-guide"><button onClick={() => setOpenGuideModal(true)}>Hướng dẫn <span>?</span></button></div>
                        <div className="classic-game-room-tabs classic-single-tab"><button>Bầu cua 60 giây</button></div>

                        <BlockchainAdminActions configLabel="Tỉ lệ & cấu hình" onConfig={() => setOpenTileModal(true)} onRoundHistory={() => { fetchHistoryPhienModal(); setOpenLichSuPhienModal(true); }} onBetHistory={() => { fetchRealBetHistory(); setOpenLichSuDatCuocModal(true); }} />


                        <BlockchainAutoControl game="baucua" />

                        {/* 4. Thẻ Kỳ số hiện tại & Đếm ngược */}
                        <Card className="classic-round-banner" sx={{ mb: 3, textAlign: "center", py: 2.5, background: "#ffffff", borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 400, color: "#1e293b", mb: 0.5, fontSize: "17px" }}>
                                Kỳ sổ: <span style={{ color: "#2563eb", fontWeight: 500 }}>{bet ? (bet.id_bet || bet._id) : "Đang tải..."}</span>
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#475569", fontWeight: 400 }}>
                                Thời gian: <strong style={{ color: "#2563eb", fontSize: "20px", fontWeight: 500 }}>00:{second < 10 ? `0${second}` : second}</strong>
                            </Typography>
                        </Card>

                        {/* 6 Cửa Đặt Bầu Cua (Bầu, Cua, Tôm, Cá, Nai, Gà) */}
                        {(() => {
                            const BAU_CUA_DOORS = [
                                { id: 3, name: "BẦU", sub: "GOURD", color: "#059669", pale: "#ecfdf5", border: "#a7f3d0" },
                                { id: 5, name: "CUA", sub: "CRAB", color: "#dc2626", pale: "#fef2f2", border: "#fecaca" },
                                { id: 2, name: "TÔM", sub: "SHRIMP", color: "#ea580c", pale: "#fff7ed", border: "#ffedd5" },
                                { id: 1, name: "CÁ", sub: "FISH", color: "#2563eb", pale: "#eff6ff", border: "#bfdbfe" },
                                { id: 4, name: "NAI", sub: "DEER", color: "#b45309", pale: "#fffbeb", border: "#fef3c7" },
                                { id: 6, name: "GÀ", sub: "ROOSTER", color: "#7c3aed", pale: "#f5f3ff", border: "#ddd6fe" }
                            ];

                            const symbolTotals = (current || []).reduce((acc, item) => {
                                const st = String(item.state || item.cuadat || "").toLowerCase();
                                const m = Number(item.money || 0);
                                if (st.includes("bầu") || st.includes("bau") || st === "3") acc[3] = (acc[3] || 0) + m;
                                else if (st.includes("cua") || st === "5") acc[5] = (acc[5] || 0) + m;
                                else if (st.includes("tôm") || st.includes("tom") || st === "2") acc[2] = (acc[2] || 0) + m;
                                else if (st.includes("cá") || st.includes("ca") || st === "1") acc[1] = (acc[1] || 0) + m;
                                else if (st.includes("nai") || st === "4") acc[4] = (acc[4] || 0) + m;
                                else if (st.includes("gà") || st.includes("ga") || st === "6") acc[6] = (acc[6] || 0) + m;
                                return acc;
                            }, { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0 });

                            const totalBetMoney = Object.values(symbolTotals).reduce((a, b) => a + b, 0);

                            return (
                                <Grid className="classic-modern-door-cards" container spacing={1.5} sx={{ mb: 3 }}>
                                    {BAU_CUA_DOORS.map((door) => {
                                        const amount = symbolTotals[door.id] || 0;
                                        const percent = totalBetMoney ? Math.round((amount / totalBetMoney) * 100) : 0;
                                        return (
                                            <Grid item xs={6} sm={4} md={2} key={door.id}>
                                                <Card sx={{ borderRadius: "12px", border: `1px solid ${door.border}`, boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)", position: "relative", bgcolor: "#ffffff" }}>
                                                    <Box sx={{ position: "absolute", inset: "0 auto 0 0", width: 4, bgcolor: door.color }} />
                                                    <Box sx={{ p: 1.5, pl: 2 }}>
                                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                            <Typography sx={{ color: door.color, fontSize: 15, fontWeight: 600 }}>{door.name}</Typography>
                                                            <Typography sx={{ color: "#64748b", fontSize: 11, fontWeight: 300 }}>{percent}%</Typography>
                                                        </Box>
                                                        <Typography sx={{ color: "#0f172a", fontSize: 16, fontWeight: 500, mt: 1 }}>{formatMoney(amount)}</Typography>
                                                        <Typography sx={{ color: "#64748b", fontSize: 11, fontWeight: 300 }}>điểm cược</Typography>
                                                    </Box>
                                                    <Box sx={{ height: 3, bgcolor: "#f1f5f9", overflow: "hidden" }}>
                                                        <Box sx={{ width: `${percent}%`, height: "100%", bgcolor: door.color, transition: "width .35s ease" }} />
                                                    </Box>
                                                </Card>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            );
                        })()}

                        {/* Thẻ Chỉnh Kết Quả Bầu Cua Phiên Hiện Tại */}
                        {bet && (
                            <Card className="classic-active-editor" sx={{ p: 2.5, mb: 3, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1.5 }}>
                                    <Box>
                                        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: 16, color: "#0f172a" }}>Chỉnh kết quả Bầu Cua phiên đang chạy</Typography>
                                        <Typography sx={{ color: "#64748b", fontSize: 13, fontWeight: 300 }}>Phiên #{bet.id_bet || bet._id} · còn {second}s (Chọn 3 linh vật)</Typography>
                                    </Box>
                                    <Chip size="small" color={second > 5 ? "success" : "warning"} label={second > 5 ? "Có thể chỉnh" : "Đã khóa"} sx={{ fontWeight: 400, borderRadius: "6px" }} />
                                </Box>
                                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(3, 1fr)", sm: "repeat(6, 1fr)" }, gap: 1, my: 1.5 }}>
                                    {[1, 2, 3, 4, 5, 6].map(sVal => {
                                        const symbolNames = { 1: "Cá", 2: "Tôm", 3: "Bầu", 4: "Nai", 5: "Cua", 6: "Gà" };
                                        const symbolColors = { 1: "#2563eb", 2: "#ea580c", 3: "#059669", 4: "#b45309", 5: "#dc2626", 6: "#7c3aed" };
                                        const activeSel = selectedResults[bet._id] || (bet.result ? String(bet.result).split(/[.,\s]+/).filter(Boolean) : []);
                                        const isSelected = activeSel.includes(String(sVal)) || activeSel.includes(sVal);
                                        return (
                                            <Button
                                                key={sVal}
                                                disabled={second <= 5}
                                                variant={isSelected ? "contained" : "outlined"}
                                                onClick={() => handleSelectSymbol(bet._id, sVal)}
                                                sx={{
                                                    height: 48,
                                                    borderRadius: "8px",
                                                    fontWeight: 500,
                                                    textTransform: "none",
                                                    bgcolor: isSelected ? symbolColors[sVal] : "#ffffff",
                                                    borderColor: symbolColors[sVal],
                                                    color: isSelected ? "#ffffff" : symbolColors[sVal],
                                                    "&:hover": { bgcolor: isSelected ? symbolColors[sVal] : `${symbolColors[sVal]}15` }
                                                }}
                                            >
                                                {symbolNames[sVal]}
                                            </Button>
                                        );
                                    })}
                                </Box>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="warning"
                                    disabled={second <= 5 || !(selectedResults[bet._id] && selectedResults[bet._id].length === 3)}
                                    onClick={() => handleUpdateRowResult(bet)}
                                    sx={{ height: 42, borderRadius: "8px", textTransform: "none", fontWeight: 400 }}
                                >
                                    Lưu kết quả phiên hiện tại {selectedResults[bet._id] && selectedResults[bet._id].length === 3 ? `(${selectedResults[bet._id].map(v => symbolNames[v]).join(" - ")})` : "(Cần chọn đủ 3 linh vật)"}
                                </Button>
                            </Card>
                        )}



                        <BlockchainClassicSummary game="baucua" bets={current} />

                        {/* 5. Bảng Soi Cược Người Chơi Trực Tiếp Phiên Hiện Tại */}
                        <Card className="classic-current-bets-hidden" sx={{ p: 2.5, mb: 3, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 500, mb: 2, color: "#0f172a", fontSize: "16px" }}>Danh Sách Người Chơi Đặt Cược Phiên Hiện Tại</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 500, color: "#475569" }}>Người chơi</TableCell>
                                        <TableCell sx={{ fontWeight: 500, color: "#475569" }}>Cửa đặt</TableCell>
                                        <TableCell sx={{ fontWeight: 500, color: "#475569" }}>Tiền cược</TableCell>
                                        <TableCell sx={{ fontWeight: 500, color: "#475569" }}>Thời gian</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {current && current.length > 0 ? (
                                        current.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell sx={{ fontWeight: 400, color: "#2563eb" }}>{item.user?.username || item.user?.name || "Người chơi"}</TableCell>
                                                <TableCell><Chip label={item.state || "Bầu"} color="primary" variant="outlined" size="small" sx={{ fontWeight: 400, borderRadius: "6px" }} /></TableCell>
                                                <TableCell sx={{ fontWeight: 400, color: "#d97706" }}>{formatMoney(item.money)}</TableCell>
                                                <TableCell sx={{ fontWeight: 300 }}>{new Date(item.createdAt).toLocaleTimeString()}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{ py: 3, color: "#64748b", fontWeight: 300 }}>
                                                Chưa có người chơi nào đặt cược ở phiên này.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>

                        {/* 6. Bảng Quản lý & Cài đặt kết quả Bầu Cua */}
                        <Card className="classic-result-table" sx={{ p: 2.5, borderRadius: "12px", border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 500, mb: 2, color: "#0f172a", fontSize: "16px" }}>Danh Sách Ván Bầu Cua & Điều Chỉnh Kết Quả</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 500, color: "#475569" }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 500, color: "#475569" }}>Kết quả hiện tại</TableCell>
                                        <TableCell sx={{ fontWeight: 500, textAlign: "center", color: "#475569" }}>Chọn 3 linh vật (1-Cá, 2-Tôm, 3-Bầu, 4-Nai, 5-Cua, 6-Gà)</TableCell>
                                        <TableCell sx={{ fontWeight: 500, textAlign: "center", color: "#475569" }}>Thao tác</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list30.slice((phienPage - 1) * 10, phienPage * 10).map((row) => {
                                        let rawBaucuaRes = selectedResults[row._id] ? (Array.isArray(selectedResults[row._id]) ? selectedResults[row._id].join(".") : selectedResults[row._id]) : row.result;
                                        const activeSel = Array.isArray(rawBaucuaRes) ? rawBaucuaRes : String(rawBaucuaRes || "").split(/[.,\s]+/).filter(Boolean);
                                        const isCurrentRound = String(row._id) === String(bet?._id);
                                        const isPast = row.createdAt && new Date(row.createdAt).getTime() + 60000 < Date.now();
                                        const isSettled = !isCurrentRound && isPast;
                                        const canPreset = !isSettled;

                                        return (
                                            <TableRow key={row._id} hover sx={{ bgcolor: isCurrentRound ? "#eff6ff" : isSettled ? "#f9fafb" : undefined }}>
                                                <TableCell sx={{ fontWeight: 400 }}>
                                                    #{row.id_bet}
                                                    {isCurrentRound && <Chip size="small" label="Đang chạy" color="primary" sx={{ ml: 1, fontWeight: 500 }} />}
                                                    {!isCurrentRound && isSettled && <Chip size="small" label="Đã khóa" sx={{ ml: 1, bgcolor: "#94a3b8", color: "#fff", fontWeight: 500 }} />}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 400, color: "#10b981" }}>
                                                    {activeSel.map(val => symbolNames[val] || val).join(" - ") || "Chưa công bố"}
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    {isSettled && !isCurrentRound ? (
                                                        <Chip size="small" label="Đã khóa" sx={{ bgcolor: "#e2e8f0", color: "#64748b", fontWeight: 500 }} />
                                                    ) : (
                                                        <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap", py: 0.5 }}>
                                                            {[1, 2, 3, 4, 5, 6].map(sVal => {
                                                                const isSelected = activeSel.includes(String(sVal)) || activeSel.includes(sVal);
                                                                return (
                                                                    <Button
                                                                        key={sVal}
                                                                        className={`baucua-symbol-btn ${isSelected ? "selected" : ""}`}
                                                                        size="small"
                                                                        disabled={!canPreset}
                                                                        variant={isSelected ? "contained" : "outlined"}
                                                                        sx={{
                                                                            fontWeight: isSelected ? 700 : 400,
                                                                            boxShadow: isSelected ? "0 0 10px rgba(37,99,235,0.4)" : "none",
                                                                            bgcolor: isSelected ? "#2563eb !important" : "#ffffff !important",
                                                                            color: isSelected ? "#ffffff !important" : "#2563eb !important",
                                                                            border: "1.5px solid #2563eb !important",
                                                                            "&:hover": isSelected ? { bgcolor: "#1d4ed8 !important" } : { bgcolor: "#eff6ff !important" }
                                                                        }}
                                                                        onClick={() => canPreset && handleSelectSymbol(row._id, sVal)}
                                                                    >
                                                                        {symbolNames[sVal]}
                                                                    </Button>
                                                                );
                                                            })}
                                                        </Box>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    {isSettled && !isCurrentRound ? (
                                                        <Chip size="small" label="Đã khóa" sx={{ bgcolor: "#e2e8f0", color: "#64748b", fontWeight: 500 }} />
                                                    ) : (
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            disabled={!canPreset || activeSel.length !== 3}
                                                            sx={{ background: canPreset ? '#ef4444' : '#94a3b8', '&:hover': { background: '#dc2626' }, fontWeight: 500, textTransform: "none", borderRadius: "6px" }}
                                                            onClick={() => handleUpdateRowResult(row)}
                                                        >
                                                            {isCurrentRound ? "Cập nhật" : "Cài trước"}
                                                        </Button>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}

                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                <Pagination
                                    count={Math.ceil(list30.length / 10) || 2}
                                    page={phienPage}
                                    onChange={(e, p) => setPhienPage(p)}
                                    color="primary"
                                    size="small"
                                />
                            </Box>
                        </Card>

                    </Container>

                    {/* MODAL 1: TỈ LỆ */}
                    <Dialog className="blockchain-data-dialog" open={openTileModal} onClose={() => setOpenTileModal(false)} maxWidth="sm" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Cấu hình Tỉ Lệ Trả Thưởng Bầu Cua</Typography>
                            <IconButton onClick={() => setOpenTileModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                {[
                                    ["single", "Một linh vật trúng 1 lần"],
                                    ["double", "Một linh vật trúng 2 lần"],
                                    ["triple", "Một linh vật trúng 3 lần"],
                                    ["tripleAny", "Bộ ba bất kỳ"],
                                    ["tripleSpecific", "Bộ ba chỉ định"],
                                    ["evenOdd", "Tài/Xỉu/Lẻ/Chẵn"],
                                    ["chooseTwo", "Chọn hai linh vật"],
                                    ["color1", "Một kết quả cùng màu"],
                                    ["color2", "Hai kết quả cùng màu"],
                                    ["color3", "Ba kết quả cùng màu"],
                                    ["allColors", "Tùy chọn ba màu"]
                                ].map(([key, label]) => (
                                    <Grid item xs={12} sm={6} key={key}>
                                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>{label}</Typography>
                                        <TextField fullWidth size="small" type="number" inputProps={{ min: 1, step: 0.01 }} value={payouts[key]} onChange={(event) => setPayouts((value) => ({ ...value, [key]: event.target.value }))} />
                                    </Grid>
                                ))}
                            </Grid>
                        </DialogContent>
                        <DialogActions sx={{ p: 2 }}>
                            <Button onClick={() => setOpenTileModal(false)} variant="outlined" sx={{ textTransform: "none", borderRadius: "8px" }}>Hủy bỏ</Button>
                            <Button onClick={savePayouts} variant="contained" color="primary" sx={{ textTransform: "none", borderRadius: "8px" }}>Cập nhật</Button>
                        </DialogActions>
                    </Dialog>

                    {/* MODAL 2: LỊCH SỬ PHIÊN (Bầu Cua chuẩn Screenshot 4) */}
                    <Dialog className="blockchain-data-dialog" open={openLichSuPhienModal} onClose={() => setOpenLichSuPhienModal(false)} maxWidth="md" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử phiên Bầu Cua</Typography>
                            <IconButton onClick={() => setOpenLichSuPhienModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                <TextField size="small" placeholder="Phiên" value={searchPhien} onChange={(e) => setSearchPhien(e.target.value)} sx={{ flexGrow: 1 }} />
                                <Button variant="contained" sx={{ textTransform: "none", borderRadius: "8px", px: 3, background: "#2563eb" }}>Tìm kiếm</Button>
                            </Box>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Kết quả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredLichSuPhien.length > 0 ? (
                                        filteredLichSuPhien.slice((lichSuPhienPage - 1) * 10, lichSuPhienPage * 10).map((row) => {
                                            const arr = row.result ? (typeof row.result === "string" ? row.result.split(/[.,\s]+/).filter(Boolean) : row.result) : [];
                                            return (
                                                <TableRow key={row._id} hover>
                                                    <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: "flex", gap: 0.5 }}>
                                                            {arr.length > 0 ? arr.map((val, idx) => (
                                                                <Chip key={idx} label={symbolNames[val] || val} size="small" color="primary" sx={{ fontWeight: 500 }} />
                                                            )) : <Chip label="Chưa xổ" size="small" sx={{ background: "#94a3b8", color: "#fff" }} />}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell style={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.totalBet || 0)}</TableCell>
                                                    <TableCell style={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.totalPay || 0)}</TableCell>
                                                    <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                                </TableRow>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                Chưa có lịch sử phiên nào đã xổ.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                <Pagination count={Math.ceil(filteredLichSuPhien.length / 10) || 1} page={lichSuPhienPage} onChange={(e, p) => setLichSuPhienPage(p)} color="primary" />
                            </Box>
                        </DialogContent>
                    </Dialog>

                    {/* MODAL 3: LỊCH SỬ ĐẶT CƯỢC */}
                    <Dialog className="blockchain-data-dialog" open={openLichSuDatCuocModal} onClose={() => setOpenLichSuDatCuocModal(false)} maxWidth="lg" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử đặt cược Bầu Cua</Typography>
                            <IconButton onClick={() => setOpenLichSuDatCuocModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                                <TextField
                                    size="small"
                                    type="date"
                                    label="Khoảng thời gian"
                                    value={searchDate}
                                    onChange={(e) => { setSearchDate(e.target.value); setLichSuDatCuocPage(1); }}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ width: 220 }}
                                />
                                <TextField
                                    size="small"
                                    placeholder="Tên người chơi"
                                    value={searchUser}
                                    onChange={(e) => { setSearchUser(e.target.value); setLichSuDatCuocPage(1); }}
                                    sx={{ flexGrow: 1 }}
                                />
                                <Button
                                    variant="contained"
                                    onClick={() => setLichSuDatCuocPage(1)}
                                    sx={{ textTransform: "none", borderRadius: "8px", px: 4, background: "#2563eb" }}
                                >
                                    Tìm kiếm
                                </Button>
                                {(searchDate || searchUser) && (
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => { setSearchDate(""); setSearchUser(""); setLichSuDatCuocPage(1); }}
                                        sx={{ textTransform: "none", borderRadius: "8px" }}
                                    >
                                        Xóa lọc
                                    </Button>
                                )}
                            </Box>

                            {(() => {
                                const formatDateYYYYMMDD = (d) => {
                                    if (!d) return "";
                                    const dateObj = new Date(d);
                                    if (isNaN(dateObj.getTime())) return "";
                                    const year = dateObj.getFullYear();
                                    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                                    const day = String(dateObj.getDate()).padStart(2, "0");
                                    return `${year}-${month}-${day}`;
                                };

                                const filteredBets = (lichSuDatCuocList || []).filter(item => {
                                    const username = item.user?.username || item.user?.name || "";
                                    const matchUser = !searchUser || username.toLowerCase().includes(searchUser.toLowerCase().trim());
                                    let matchDate = true;
                                    if (searchDate) {
                                        const itemDate = formatDateYYYYMMDD(item.createdAt);
                                        matchDate = itemDate === searchDate;
                                    }
                                    return matchUser && matchDate;
                                });
                                const totalBet = filteredBets.reduce((acc, curr) => acc + (Number(curr.money) || 0), 0);
                                const totalWin = filteredBets.reduce((acc, curr) => acc + (Number(curr.moneythang) || 0), 0);
                                return (
                                    <>
                                        <Grid container spacing={2} sx={{ mb: 2 }}>
                                            <Grid item xs={6}>
                                                <Card sx={{ background: "#e0f2fe", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                                    <Typography variant="body2" color="#0369a1" fontWeight={500}>Tổng cược</Typography>
                                                    <Typography variant="h5" color="#0284c7" fontWeight={700}>{formatMoney(totalBet)}</Typography>
                                                </Card>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Card sx={{ background: "#dcfce7", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                                    <Typography variant="body2" color="#15803d" fontWeight={500}>Tổng thắng</Typography>
                                                    <Typography variant="h5" color="#16a34a" fontWeight={700}>{formatMoney(totalWin)}</Typography>
                                                </Card>
                                            </Grid>
                                        </Grid>

                                        <Table size="small">
                                            <TableHead>
                                                <TableRow sx={{ background: "#f8fafc" }}>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tên tài khoản</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Thể loại</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Cửa đặt</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Thanh toán</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {filteredBets.length > 0 ? (
                                                    filteredBets.slice((lichSuDatCuocPage - 1) * 10, lichSuDatCuocPage * 10).map((row, idx) => (
                                                        <TableRow key={idx} hover>
                                                            <TableCell sx={{ fontWeight: 500, color: "#2563eb" }}>{row.user?.username || row.user?.name || "Người chơi"}</TableCell>
                                                            <TableCell>60s Sảnh {sanhLetters[SANH_ID - 1]}</TableCell>
                                                            <TableCell>{row.id_bet?.id_bet || row.id_bet || "-"}</TableCell>
                                                            <TableCell><Chip label={row.state || "Bầu 🎃"} size="small" color="primary" /></TableCell>
                                                            <TableCell sx={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.money)}</TableCell>
                                                            <TableCell sx={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.moneythang || 0)}</TableCell>
                                                            <TableCell sx={{ color: "#64748b" }}>{["Win", "Lose", "Cancelled"].includes(row.status_bet) ? "Đã thanh toán" : "Đang chờ"}</TableCell>
                                                            <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                            Chưa có lịch sử đặt cược nào trong hệ thống.
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                            <Pagination count={Math.ceil(filteredBets.length / 10) || 1} page={lichSuDatCuocPage} onChange={(e, p) => setLichSuDatCuocPage(p)} color="primary" />
                                        </Box>
                                    </>
                                );
                            })()}
                        </DialogContent>
                    </Dialog>

                    <BlockchainGameGuideModal open={openGuideModal} onClose={() => setOpenGuideModal(false)} />
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetBauCua60s;
